<template>
  <section id="how-it-works" class="bg-white py-20 md:py-28">
    <div class="mx-auto max-w-6xl px-4 md:px-6">
      <div class="mb-14 text-center">
        <p class="mb-3 text-xs font-semibold uppercase tracking-widest text-muted-foreground">
          {{ $ts('howItWorks.label') }}
        </p>
        <h2 class="text-4xl font-bold leading-[1.05] tracking-tight text-foreground md:text-5xl">
          {{ $ts('howItWorks.title') }}
        </h2>
        <p class="mx-auto mt-4 max-w-xl text-lg text-muted-foreground">
          {{ $ts('howItWorks.subtitle') }}
        </p>
      </div>

      <div class="grid gap-5 md:grid-cols-3">
        <div
          v-for="(step, i) in steps"
          :key="i"
          class="group flex flex-col rounded-3xl border border-border/50 bg-white p-7 transition-transform hover:scale-[1.005]"
        >
          <div class="mb-5 flex items-center justify-between">
            <span class="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-foreground text-sm font-bold text-background">
              {{ i + 1 }}
            </span>
            <Icon :name="step.icon" size="32" class="text-muted-foreground/50" />
          </div>
          <h3 class="text-lg font-bold text-foreground">{{ step.title }}</h3>
          <p class="mt-2 text-sm leading-relaxed text-muted-foreground">{{ step.description }}</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useI18n, useSchemaOrg, defineHowTo } from '#imports';

const { $ts } = useI18n();

const steps = computed(() => [
  { icon: 'tabler:clipboard-list', title: $ts('howItWorks.step1.title'), description: $ts('howItWorks.step1.description') },
  { icon: 'tabler:robot',          title: $ts('howItWorks.step2.title'), description: $ts('howItWorks.step2.description') },
  { icon: 'tabler:video',          title: $ts('howItWorks.step3.title'), description: $ts('howItWorks.step3.description') },
]);

useSchemaOrg([
  defineHowTo({
    name: () => $ts('howItWorks.title'),
    step: steps.value.map(s => ({ name: s.title, text: s.description })),
  }),
]);
</script>
